/**
 * CartSettingsContainer
 * --
 */
import React from 'react';
import CartSettingsPresenter from './CartSettingsPresenter';

const CartSettingsContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <CartSettingsPresenter />
    </>
  );
};

export default CartSettingsContainer;
